import PropTypes from 'prop-types';

export const BtnPublicarSeller = ({ estado, inCreate, setEstado, isAdminMod, isCategory }) => {
    const cantPublicarSeller = () => {
        return (inCreate || estado === "pendiente_activacion" || estado === "en_revision" || estado === "activo") && (!isCategory && !isAdminMod)
    }

    if (cantPublicarSeller) {
        return null;
    }

    if (!isCategory && !isAdminMod) {
        return (
            <button
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
                disabled={
                    inCreate ||
                    estado !== "pausado"
                }
                name="activo"
                onClick={setEstado}
            >
                Publicar
            </button>
        );
    }

    return null;
}
BtnPublicarSeller.propTypes = {
    estado: PropTypes.string,
    inCreate: PropTypes.bool,
    setEstado: PropTypes.func,
    isAdminMod: PropTypes.bool,
    isCategory: PropTypes.bool
}